export default __webpack_public_path__ + "static/media/credit-card.c4a26282.svg";